export const MCP_OAUTH_CHANNEL = "dante-mcp-oauth";
